import React, { useRef, useEffect, useState } from 'react';
import { useTranslate } from 'react-admin';
import { Box, Typography } from '@mui/material';
import { Growth } from '@/components/analytics/common/Growth.jsx';
import { Bar, ReferenceLine, Cell } from 'recharts';
import { getFillColor } from '@/components/analytics/common/BarChartWithTrend.jsx';
import { RoundedTopBar } from '@/components/device/details/TransactionsStatsContent.jsx';
import { StatsSparklineChart } from '@/components/device/details/StatsSparklineChart.jsx';
import { Palette } from '@/themes/themeOverrides/Palette';

const CollectedPackagesStatsContent = ({ transactionStats, growth, chartData, avg, theme, barColorThresholds }) => {
    const translate = useTranslate();
    const chartRef = useRef();
    const [y1, setY1] = useState(null);
    useEffect(() => {
        if (chartRef.current) {
            const refLine = chartRef.current.querySelector('.recharts-reference-line-line');
            if (refLine) {
                setY1(refLine.getAttribute('y1'));
            }
        }
    }, [chartData, avg, theme, barColorThresholds, transactionStats]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '29px' }}>
                <Typography variant='h3'>{transactionStats?.transactionsValidContainersCount}</Typography>
                <Growth value={growth} />
            </Box>
            <Box ref={chartRef} sx={{ position: 'relative', display: 'flex', flexWrap: 'nowrap', alignItems: 'flex-start', gap: '16px' }}>
                <StatsSparklineChart data={chartData} dataKey='transactionsValidContainersCount'>
                    <Bar dataKey='transactionsValidContainersCount' fill='#8884d8' radius={2} background={<RoundedTopBar />}>
                        {chartData.map(entry => (
                            <Cell
                                key={entry.periodStart?.date ?? entry.periodEnd?.date}
                                fill={getFillColor(avg, entry.transactionsValidContainersCount, theme, barColorThresholds)}
                            />
                        ))}
                    </Bar>
                    <ReferenceLine y={avg} stroke={Palette.white} strokeWidth={2} />
                </StatsSparklineChart>
                {transactionStats?.transactionsValidContainersCount > 0 && (
                    <Typography variant='caption' fontSize={10} fontWeight={700} sx={y1 ? { marginTop: `calc(${y1}px - 8px)` } : undefined}>
                        {translate('resources.device.labels.average')}
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default CollectedPackagesStatsContent;
